import { apiClient } from '@/lib/api-client';
import type { ApiSuccess } from '@/lib/api-client';
import type { BatchCloseContext } from './types';

/**
 * Close-delay API.
 *
 * Endpoints (SPEC v1.0 §18 — see monthly_batches/routes.rs):
 *   GET  /api/monthly-batches/:id                 batch (read case_code + close_deadline)
 *   POST /api/monthly-batches/:id/delay-reason    { reason }  (monthly_close.delay_explain)
 *   POST /api/monthly-batches/:id/confirm-delay               (monthly_close.approve)
 *
 * Both writes return the updated batch. Confirm requires a delay reason to
 * have been recorded first (enforced backend-side).
 */

/** GET the batch (read-only context: case_code + close_deadline + status). */
export const fetchBatchCloseContext = async (batchId: string): Promise<BatchCloseContext> => {
  const res = await apiClient.get<ApiSuccess<BatchCloseContext>>(`/monthly-batches/${batchId}`);
  return res.data.data;
};

/** POST record the overdue-close delay reason. */
export const recordDelayReason = async (
  batchId: string,
  reason: string,
): Promise<BatchCloseContext> => {
  const res = await apiClient.post<ApiSuccess<BatchCloseContext>>(
    `/monthly-batches/${batchId}/delay-reason`,
    { reason },
  );
  return res.data.data;
};

/** POST confirm the recorded delay, clearing the overdue close gate. */
export const confirmDelay = async (batchId: string): Promise<BatchCloseContext> => {
  const res = await apiClient.post<ApiSuccess<BatchCloseContext>>(
    `/monthly-batches/${batchId}/confirm-delay`,
  );
  return res.data.data;
};
